'use client';
import { useTranslation } from 'react-i18next';
import Card from 'apollo-react/components/Card';
import Info from 'apollo-react-icons/Info';
import './NodeCard.css';

export default function NodeCard({
  node,
  addChild,
  onEditClick,
  onDeleteClick,
  showViewButtonInNode = false,
  showEditButtonInNode = true,
  showAddChildButtonInNode = true,
  showDeleteButtonInNode = true,
}) {
  const { t } = useTranslation();

  return (
    <Card className="node-card">
      <div className="card-content">
        <div className="info-section">
          <div className="info-row">
            <div className="info-label">
              <span>Dep</span>
              <Info className="info-icon" />
            </div>
            <div className="info-value">{node.name}</div>
          </div>
          <div className="info-row">
            <div className="info-label">
              <span>Code</span>
              <Info className="info-icon" />
            </div>
            <div className="info-value">{node.code}</div>
          </div>
          <div className="info-row">
            <div className="info-label">
              <span>Level</span>
              <Info className="info-icon" />
            </div>
            <div className="info-value">{node.level}</div>
          </div>
        </div>
        {showViewButtonInNode && (
          <div className="button-section">
            <button
              onClick={() => {
                onEditClick('viewModal', node);
              }}
              className="view-button"
            >
              {t('view')}
            </button>
          </div>
        )}
        {(showEditButtonInNode ||
          showAddChildButtonInNode ||
          showDeleteButtonInNode) && (
          <div className="button-section">
            {showEditButtonInNode && (
              <button
                onClick={() => {
                  onEditClick('editModal', node);
                }}
                className="edit-button"
              >
                {t('edit')}
              </button>
            )}
            {showAddChildButtonInNode && (
              <button
                onClick={() => {
                  addChild(node);
                }}
                className="add-child-button"
              >
                {t('add_child')}
              </button>
            )}
            {showDeleteButtonInNode &&
              onDeleteClick &&
              !node.isNew &&
              (!node.children || node.children.length === 0) && (
                <button
                  onClick={() => onDeleteClick(node)}
                  className="delete-button"
                >
                  {t('delete')}
                </button>
              )}
          </div>
        )}
      </div>
    </Card>
  );
}
